import alert from './icons/alert.svg'
import badgePercent from './icons/badge-percent.svg'
import bill from './icons/bill.svg'
import check from './icons/check.svg'
import circleInfo from './icons/circle-info.svg'
import coins from './icons/coins.svg'
import copy from './icons/copy.svg'
import cross from './icons/cross.svg'
import fromManyToOne from './icons/from-many-to-one.svg'
import fromOneToMany from './icons/from-one-to-many.svg'
import maxLogo from './icons/max-logo.svg'
import office from './icons/office.svg'
import straightDottedLine from './icons/straight-dotted-line.svg'
import tBankLogo from './icons/t-bank-logo.svg'
import telegramLogo from './icons/telegram-logo.svg'
import user from './icons/user.svg'

export const icons = {
  circleInfo,
  badgePercent,
  copy,
  maxLogo,
  telegramLogo,
  tBankLogo,
  bill,
  cross,
  user,
  office,
  alert,
  straightDottedLine,
  coins,
  fromManyToOne,
  fromOneToMany,
  check,
} as const
